function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

// Shopify injects accelerated-payment controls after the theme has rendered.
// Give only the known payment controls names; do not guess labels for arbitrary
// role=button elements supplied by apps.
(function () {
  if (window.__pfDynamicControlNames) return;
  window.__pfDynamicControlNames = true;

  function nameDynamicPaymentControls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.shopify-payment-button__button[role="button"]:not([aria-label])')) {
      scope.setAttribute('aria-label', 'Buy it now');
    }
    if (scope.matches && scope.matches('.shopify-payment-button__more-options[role="button"]:not([aria-label])')) {
      scope.setAttribute('aria-label', 'More payment options');
    }
    scope.querySelectorAll('.shopify-payment-button__button[role="button"]:not([aria-label])').forEach(function (button) {
      button.setAttribute('aria-label', 'Buy it now');
    });
    scope.querySelectorAll('.shopify-payment-button__more-options[role="button"]:not([aria-label])').forEach(function (button) {
      button.setAttribute('aria-label', 'More payment options');
    });
  }

  function startDynamicControlObserver() {
    document.querySelectorAll('a[target="_blank"]:not([rel~="noopener"])').forEach(function (link) {
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (!rel.includes('noopener')) rel.push('noopener');
      if (!rel.includes('noreferrer')) rel.push('noreferrer');
      link.setAttribute('rel', rel.join(' '));
    });
    nameDynamicPaymentControls(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') nameDynamicPaymentControls(record.target);
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) nameDynamicPaymentControls(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'role'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startDynamicControlObserver, { once: true });
  } else {
    startDynamicControlObserver();
  }
})();

// Stock is rendered from the same server-side variant facts as the initial page.
// Update only the product that dispatched the selection; never infer stock from price.
(function () {
  function updateStock(event, deselected) {
    var detail = event.detail;
    if (!detail || !detail.product) return;
    document.querySelectorAll('[data-pf-product-stock]').forEach(function (holder) {
      if (holder.dataset.pfProductStock !== String(detail.product.id)) return;
      var output = holder.querySelector('[data-pf-stock-message]');
      if (!output) return;
      var variant = detail.selectedVariant;
      var template = !deselected && variant && Array.from(holder.querySelectorAll('[data-pf-stock-variant]')).find(function (item) {
        return item.dataset.pfStockVariant === String(variant.id);
      });
      if (template) output.replaceChildren(template.content.cloneNode(true));
      else output.textContent = 'Choose an option to check availability';
    });
  }
  document.addEventListener('booster:variant:select', function (event) { updateStock(event, false); });
  document.addEventListener('booster:variant:deselect', function (event) { updateStock(event, true); });
})();

// Keep payment estimates and accessible cart names tied to Booster's actual
// variant/cart events. These listeners never alter the selected product or cart.
(function () {
  if (window.__pfPurchaseMessages) return;
  window.__pfPurchaseMessages = true;
  var booster;

  function productQuantity(message) {
    var form = document.getElementById('product_form_' + message.dataset.bnplProduct);
    var input = form && form.querySelector('[name="quantity"]');
    var quantity = input ? Number(input.value) : 1;
    return Number.isSafeInteger(quantity) && quantity > 0 && (!input || validPurchaseQuantity(input)) ? quantity : null;
  }

  function quantityProductId(input) {
    if (input.dataset.pfProductQuantity) return input.dataset.pfProductQuantity;
    var form = input.closest('form[id^="product_form_"]');
    // The product form's hidden input[name=id] shadows form.id in browsers.
    return form ? form.getAttribute('id').slice('product_form_'.length) : null;
  }

  function syncProductQuantity(input) {
    var id = quantityProductId(input);
    if (!id) return;
    var form = document.getElementById('product_form_' + id);
    var main = form && form.querySelector('[name="quantity"]');
    if (!main) return;
    main.value = input.value;
    main.setCustomValidity('');
    document.querySelectorAll('[data-pf-product-quantity]').forEach(function (sticky) {
      if (sticky.dataset.pfProductQuantity === id) {
        sticky.value = input.value;
        sticky.setCustomValidity('');
      }
    });
  }

  function validPurchaseQuantity(input) {
    var value = Number(input.value);
    return Number.isSafeInteger(value) && value > 0 && input.validity.valid;
  }

  function guardPurchase(event, form, trigger) {
    var input = form && form.querySelector('[name="quantity"]');
    if (!input || validPurchaseQuantity(input)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var sticky = trigger && trigger.closest('.product-page-sticky--atc');
    var visibleInput = sticky && sticky.querySelector('[data-pf-product-quantity]');
    var field = visibleInput || input;
    if (field.validity.valid) field.setCustomValidity('Enter a whole-number quantity of at least 1.');
    field.reportValidity();
  }

  function renderEstimate(message) {
    var quantity = message.hasAttribute('data-bnpl-cart') ? 1 : productQuantity(message);
    var price = Number(message.dataset.bnplPrice);
    var valid = quantity !== null && Number.isSafeInteger(price) && Number.isSafeInteger(price * quantity) && price > 0 && message.dataset.bnplUnavailable !== 'true';
    message.hidden = !valid;
    if (!valid) return;
    // Round cents, then label the amount approximate: four equal rounded
    // instalments need not sum exactly to an odd-cent purchase total.
    var instalment = Math.round(price * quantity / 4) / 100;
    var formatted;
    try {
      formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency', currency: message.dataset.bnplCurrency || 'AUD', currencyDisplay: 'code'
      }).format(instalment);
    } catch (error) {
      message.hidden = true;
      return;
    }
    var amount = message.querySelector('[data-bnpl-instalment]');
    var quantityText = message.querySelector('[data-bnpl-quantity]');
    if (amount && amount.textContent !== formatted) amount.textContent = formatted;
    var suffix = quantity > 1 ? ' for ' + quantity + ' items' : '';
    if (quantityText && quantityText.textContent !== suffix) quantityText.textContent = suffix;
  }

  function renderProducts() {
    document.querySelectorAll('[data-pf-bnpl][data-bnpl-product]').forEach(renderEstimate);
  }

  function applyVariant(detail, unavailable) {
    if (!detail || !detail.product) return;
    document.querySelectorAll('[data-pf-bnpl][data-bnpl-product]').forEach(function (message) {
      if (message.dataset.bnplProduct !== String(detail.product.id)) return;
      var variant = detail.selectedVariant;
      message.dataset.bnplUnavailable = String(unavailable || !variant || variant.available === false);
      // Booster's price is formatted text; price_raw is the integer cents.
      if (variant) message.dataset.bnplPrice = String(variant.price_raw);
      renderEstimate(message);
    });
  }

  function updateCartNames(count) {
    if (!Number.isSafeInteger(count) || count < 0) return;
    document.querySelectorAll('.minicart__label[data-cart-container]').forEach(function (control) {
      control.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function applyCart(detail) {
    if (!detail || !detail.data) return;
    updateCartNames(detail.data.item_count);
    if (typeof detail.data.total_raw !== 'number') return;
    document.querySelectorAll('[data-pf-bnpl][data-bnpl-cart]').forEach(function (message) {
      message.dataset.bnplPrice = String(detail.data.total_raw);
      renderEstimate(message);
    });
  }

  function refresh(event) {
    if (event && event.detail && event.detail.BoosterTheme) booster = event.detail.BoosterTheme;
    // Booster uses a global lexical constant, not a window property. Its
    // initialized event fires before that constant has finished construction.
    if (!booster) {
      try { if (typeof BoosterTheme !== 'undefined') booster = BoosterTheme; } catch (error) { /* Wait for loaded. */ }
    }
    document.querySelectorAll('[data-pf-bnpl]').forEach(renderEstimate);
    var cart = booster && booster.cart;
    if (cart && cart.minicart) applyCart(cart.minicart);
  }

  document.addEventListener('booster:variant:select', function (event) { applyVariant(event.detail, false); });
  document.addEventListener('booster:variant:deselect', function (event) { applyVariant(event.detail, true); });
  document.addEventListener('booster:cart:update', function (event) { applyCart(event.detail); });
  document.addEventListener('booster:initialized', refresh);
  document.addEventListener('booster:loaded', refresh);
  document.addEventListener('booster:content:update', refresh);
  ['input', 'change'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.target.matches('[name="quantity"]')) {
        syncProductQuantity(event.target);
        renderProducts();
      }
    });
  });
  // Booster's AJAX buttons bypass native form validity checks. Do not let a
  // temporarily blank, zero or invalid quantity submit a stale purchase value.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-buy-button], [data-buy-now]');
    if (!button) return;
    var form = button.closest('form[id^="product_form_"]') || document.getElementById('product_form_' + button.dataset.buyButton);
    guardPurchase(event, form, button);
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[id^="product_form_"]')) guardPurchase(event, event.target);
  }, true);
  // Booster's +/- handlers change .value without emitting input/change.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.quantity--input__button');
    if (!button) return;
    var input = button.parentElement.querySelector('[name="quantity"]');
    if (input) syncProductQuantity(input);
    renderProducts();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
